module.exports = __webpack_public_path__ + "img/pic6.1e3b40d9.png";